import core from 'src/assets/images/tokens/core.png';
import { StaticImageData } from 'next/image';

export const ICONS_STORE: { [key: string]: StaticImageData } = {
  CORE: core,
  tCORE: core
};
